goals_handler = {

    properties: {
    },

    onLoad: function(){
        var self = this;

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large secondary-bg background-img');
    },


    events: function() {
        var self = this;
        self.onLoad();

    }
}
